import { IGatsbyImageDataObject } from '@et/types/Gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import React from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component'

interface Props {
  image?: IGatsbyImageDataObject
}
function ProcreateIntroPart2(props: Props) {
  const { image } = props
  return (
    <div className='pb-12 et-grid-basic md:pt-16 md:pb-48 lg:pb-16 xl:pt-28'>

      <div className='hidden md:block md:col-start-1 md:col-span-6 lg:ml-[-50px] lg:mr-[25px] lg:col-start-3 lg:col-span-5 xl:mr-0 xl:ml-20 xl:col-start-2 xl:col-span-5'>
        {image && <div className='relative'>
          <GatsbyImage alt="image 1" image={image.gatsbyImageData} className='relative w-full xl:top-[-150px] xl:ml-[-100px] xxl:top-[-75px]' />
          <div className='absolute bottom-[-135px] left-[20px] w-[200px] lg:bottom-auto lg:top-[135px] lg:left-[-50px] shadow-2xl xl:w-[300px] xl:left-auto xl:right-[-20px] xxl:top-[200px]'>
            <LazyLoadImage
              alt={'Repeat pattern with white hairline in Procreate.'}
              height={571}
              visibleByDefault={false}
              src={'https://et-teachable.imgix.net/procreate-patterns/white-hairline.gif'} // use normal <img> attributes as props
              width={478} />
          </div>
        </div>}

      </div>

      {/* CONTENT */}
      <div className='flex flex-col col-span-2 col-start-2 md:col-start-7 md:col-span-7 md:pr-3 lg:col-start-8 lg:col-span-6 lg:pr-0'>
        <h2 className='section-h2 font-sentinel__SemiBoldItal'>
          But surely the testing is easy and fun?
        </h2>
        <span className='my-4 text-5xl text-rusted-400 xl:text-6xl xl:-ml-16 xl:my-8'>Riiiight.</span>
        <p className='text-lg xl:text-xl'>There's the scaling it down (perfectly), lining it up (perfectly), waiting for it to snap in *just* the right places and hoping. <span className='italic'>Really</span> hoping it all works out. And let's not get into when a *little* white hairline seemingly appears OUT OF NOWHERE and you have to start <span className='italic'>all</span> over. 🤦‍♀️</p>
        <p className='mt-4 text-2xl font-bold'>*the* worst.</p>
      </div>
    </div>
  )
}

export default ProcreateIntroPart2
